import { css } from '@emotion/react';
import { textLargeBodyFontSize } from 'styles/global_defaults/fonts';
import { MentoringProgramRole } from 'redux/schemas/models/mentoring-program-enrollments';
import ParticipantPill from 'athena/components/participant-pill';

const styles = css`
  .question-text {
    font-size: ${textLargeBodyFontSize}px;
    line-height: 100%;
  }
`;

type ParticipantQuestionPillProps = {
  role: MentoringProgramRole;
  question: string;
  className?: string;
};

const ParticipantQuestionPill = ({
  role,
  question,
  className,
}: ParticipantQuestionPillProps) => (
  <div css={styles} className={`d-flex align-items-center ${className ?? ''}`}>
    <ParticipantPill role={role} />
    <div className='question-text semi-bold'>
      {question}
    </div>
  </div>
);

export default ParticipantQuestionPill;
